import React, { useContext, useEffect, useState } from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { Loading } from '../../components/Loading';
import { growlErrors } from '../../utils/NotificationUtil';
import { AccountContext } from '../../components/AccountContext';
import { NotificationContext } from '../../components/GrowlNotifications';
import ChangeSubscription from './ChangeSubscription';

const ACCOUNT_QUERY = gql`
  query accountQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      displayName
      type
      subscriptionInformation {
        currentSubscription {
          numberOfEmployees
          duration
          subscriptionPeriodId
          payedAmount
        }
      }
    }
  }
`;

const DEFAULT_ACCOUNT_STATE = {
  id: null,
  displayName: null,
  type: null,
  subscriptionInformation: {
    currentSubscription: {
      numberOfEmployees: null,
      subscriptionPeriodId: null,
      payedAmount: null,
    },
  },
};

const ChangeOwnSubscription = () => {
  const [account, setAccount] = useState(DEFAULT_ACCOUNT_STATE);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const { loading, error, data } = useQuery(ACCOUNT_QUERY, {
    variables: {
      accountId: currentAccount,
    },
  });

  const { account: accountFromQuery } = data;

  useEffect(() => {
    if (accountFromQuery) {
      setAccount(accountFromQuery);
    }
  }, [accountFromQuery]);

  if (loading || account === DEFAULT_ACCOUNT_STATE) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  return <ChangeSubscription managingAccount={account} clientAccount={account} />;
};

export default ChangeOwnSubscription;
